import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31f2b6bf&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=31f2b6bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f2b6bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31f2b6bf')) {
      api.createRecord('31f2b6bf', component.options)
    } else {
      api.reload('31f2b6bf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31f2b6bf&scoped=true&", function () {
      api.rerender('31f2b6bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chronic/index.vue"
export default component.exports